import { debounce as lodashDebounce } from 'lodash';

const _debounce: (action: <T = any>(...args) => T | void, timeMs: number) => <T = any>(...args) => T = lodashDebounce;

export const debounce = _debounce;
export default _debounce;
